import { Alert, AlertNotification, DailyActivesFrequency, SegmentKey } from '@fullstory/client-api';
import { emitSExpr } from '@fullstory/util/sexpr';
import { intl } from '@fullstory/intl';

export const notificationText = (notification: AlertNotification): string => {
  const settings = notification.Alert.Settings;
  return intl.formatMessage(
    {
      defaultMessage:
        'The {frequence, select, daily {daily} weekly {weekly} monthly {monthly} other {}} active user count {aboveOrBelow, select, true {went above} other {dropped below}} {amount, number} on {timestamp, date, ::MMMM d} at {timestamp, time, short}',
      id: '0SYn1q',
    },
    {
      frequence: frequency(settings.NDayActive),
      aboveOrBelow: settings.Above,
      amount: settings.Value,
      timestamp: notification.OccurredAt,
    },
  );
};

export const frequency = (f: DailyActivesFrequency): string => {
  switch (f) {
    case DailyActivesFrequency.Daily:
      return 'daily';
    case DailyActivesFrequency.Weekly:
      return 'weekly';
    case DailyActivesFrequency.Monthly:
      return 'monthly';
    default:
      console.error(`unknown DailyActivesFrequency ${f}`);
      return '';
  }
};

export const alertSexpr = (alert: Alert) =>
  `:${emitSExpr([
    {
      value: encodeURIComponent(
        JSON.stringify({
          Actives: [alert.Settings.NDayActive],
          ComputePast: false,
          ComputeRatio: false,
          AlignWeekdays: true,
        }),
      ),
    },
  ])}`;

export function segmentIdFromKey<T extends SegmentKey>(key: T): string {
  return key.SegmentName ? key.SegmentName : `${key.SeatName}:${key.SegmentId}`;
}
